import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import aprReport from '@/shared/http/repositories/business/aprReport'

export default {
  name: 'aprReportTable',
  components: {},
  mixins: [ActionsForm],
  data () {
    return {
      formSearch: {},
      dataQuatitativos: {}
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      loading.push()
      aprReport.GetRelatorioQuantidadeAPR(this.formSearch)
        .then((Response) => {
          loading.pop()
          this.dataQuatitativos = Response.data
          this.$emit('quantitativos', this.dataQuatitativos)
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/aprReport/components/aprReportTable/components/aprPainelReport/aprPainelReport.js